import { Component, inject, input } from '@angular/core';
import { KioskGlobalSettings } from '@core/models/kiosk-global-settings.model';
import { provideKioskGlobalSettingsToken } from '@core/services/kiosk/kiosk-global-settings.token';
import { KioskService } from '@core/services/kiosk/kiosk.service';

@Component({
  selector: 'app-kiosk-main-layout',
  templateUrl: './kiosk-main-layout.component.html',
  providers: [
    provideKioskGlobalSettingsToken(() => inject(KioskMainLayoutComponent).kioskGlobalSettings),
  ],
})
export class KioskMainLayoutComponent {
  private readonly kioskService = inject(KioskService);

  readonly footer = input<unknown[]>([]);
  readonly globalFeatures = input<unknown[]>([]);
  readonly kioskGlobalSettings = input<Partial<KioskGlobalSettings>>();

  constructor() {
    this.kioskService.saveKioskLayoutToStore(true);
  }
}
